<template>
  <div class="modal-body">
    <form @submit.prevent="handleSubmit">
      <!-- Alerts -->
      <div v-if="successMessage" class="alert alert-success">
        {{ successMessage }}
      </div>

      <div v-if="errorMessage" class="alert alert-danger">
        {{ errorMessage }}
      </div>

      <!-- Grade -->
      <div class="mb-3">
        <label class="form-label">Grade</label>
        <select class="form-select" v-model="editTopic.grade_id" required>
          <option value="" disabled>Select Grade</option>
          <option v-for="g in grades" :key="g.id" :value="g.id">
            {{ g.level }}
          </option>
        </select>
      </div>

      <!-- Subject -->
      <div class="mb-3">
        <label class="form-label">Subject</label>
        <select
          class="form-select"
          v-model="editTopic.subject_id"
          :disabled="!editTopic.grade_id"
          required
        >
          <option value="" disabled>Select Subject</option>
          <option v-for="s in subjects" :key="s.id" :value="s.id">
            {{ s.name }}
          </option>
        </select>
      </div>

      <!-- Title -->
      <div class="mb-3">
        <label class="form-label">Topic Title</label>
        <input
          type="text"
          class="form-control"
          v-model="editTopic.title"
          required
        />
      </div>

      <!-- Description -->
      <div class="mb-3">
        <label class="form-label">Description</label>
        <textarea
          class="form-control"
          v-model="editTopic.description"
          rows="3"
        ></textarea>
      </div>

      <!-- Footer -->
      <div class="modal-footer p-0 mt-3">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
          Close
        </button>

        <button type="submit" class="btn btn-pink" :disabled="loading">
          <span
            v-if="loading"
            class="spinner-border spinner-border-sm me-2"
          ></span>
          {{ loading ? "Saving..." : "Save" }}
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "EditTopic",

  props: {
    topic: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      grades: [],
      subjects: [],
      loading: false,
      errorMessage: "",
      successMessage: "",

      editTopic: {
        id: "",
        grade_id: "",
        subject_id: "",
        title: "",
        description: "",
      },
    };
  },

  watch: {
    topic: {
      immediate: true,
      async handler(val) {
        if (val) {
          this.editTopic = { ...val };

          if (this.editTopic.grade_id) {
            await this.fetchSubjectsByGrade();
            this.editTopic.subject_id = val.subject_id;
          }
        }
      },
    },

    "editTopic.grade_id"(newVal) {
      this.editTopic.subject_id = "";
      this.subjects = [];

      if (newVal) {
        this.fetchSubjectsByGrade();
      }
    },
  },

  mounted() {
    this.fetchGrades();
  },

  methods: {
    async fetchGrades() {
      try {
        const res = await axios.get("/a-get-grades");
        this.grades = res.data;
      } catch (error) {
        console.error(error);
      }
    },

    async fetchSubjectsByGrade() {
      try {
        const res = await axios.get(
          `/a-grade-subjects?grade_id=${this.editTopic.grade_id}`,
        );

        this.subjects =
          res.data.subjects ||
          res.data.map((s) => ({
            id: s.subject.id,
            name: s.subject.name,
          }));
      } catch (error) {
        console.error(error);
        this.subjects = [];
      }
    },

    async handleSubmit() {
      try {
        this.loading = true;
        this.errorMessage = "";
        this.successMessage = "";

        const res = await axios.put(
          `/a-update-topic/${this.editTopic.id}`,
          this.editTopic,
        );

        this.successMessage = "Topic updated successfully!";

        this.$emit("topic-updated", res.data.topic);
      } catch (error) {
        this.errorMessage =
          error.response?.data?.message || "Something went wrong.";
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.btn-pink {
  background-color: #ff00cc;
  border: none;
  color: white;
}

.btn-pink:hover {
  background-color: #e600b3;
}
</style>
